<template>
	<div :id="modal_id" class="modal fade" :ref="modal_id">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<button
					type="button"
					@click="() => setModalOpen(false)"
					class="button dismiss-button ion ion-ios-close"
					data-dismiss="modal"
				></button>
				<div class="modal-body" v-if="product">
					<div class="row">
						<div class="col-lg-6 col-md-6 col-sm-12">
							<!-- Product-zoom-area -->
							<img
								class="img-fluid"
								:src="
									API_URL +
									'/storage/uploads/' +
									(product.product.images.length > 0
										? product.product.images[0].name
										: 'no-image.png')
								"
								@error="$event.target.src = 'https://fl-1.cdn.flockler.com/embed/not-found.png'"
								alt="Product"
							/>
							<!-- Product-zoom-area /- -->
						</div>
						<div class="col-lg-6 col-md-6 col-sm-12">
							<!-- Product-details -->
							<div class="all-information-wrapper" v-if="product">
								<div class="section-1-title-breadcrumb-rating">
									<div class="product-title">
										<h1>
											<a href="single-product.html"
												><b>{{ product.product.product_name }}</b></a
											>
										</h1>
									</div>
								</div>
								<div class="section-2-short-description u-s-p-y-14">
									<h6 class="information-heading u-s-m-b-8">Warehouse:</h6>
									<p>
										{{ product.warehouse_name }}
									</p>
								</div>
								<div class="section-3-price-original-discount u-s-p-y-14">
									<div class="price">
										<h4>
											{{ formatCurrency(product.unit_price) }} * {{ product.qty }}
										</h4>
									</div>
								</div>
								<div class="section-4-sku-information u-s-p-y-14">
									<h6 class="information-heading u-s-m-b-8">Product Information:</h6>
									<div
										class="left"
										v-for="av in product.combination.attribute_variations"
										:key="av.id"
									>
										<span>{{ av.attribute.name }}:</span>
										<span>{{ av.variation.name }}</span>
									</div>
								</div>

								<div class="section-6-social-media-quantity-actions u-s-p-y-14">
									<form action="#" class="post-form">
										<div>
											<button
												class="button button-outline-secondary ml-2"
												type="button"
												data-dismiss="modal"
												@click="redirectToCheckout"
											>
												Proceed to Checkout
											</button>
											<button
												class="button button-outline-secondary ml-2"
												type="button"
												data-dismiss="modal"
											>
												Add More
											</button>
										</div>
									</form>
								</div>
							</div>
							<!-- Product-details /- -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {formatCurrency} from "../../utils/common_functions";
	import {mapGetters, mapActions} from "vuex";
	export default {
		props: ["modal_id", "product_id", "combination_id"],
		computed: {...mapGetters("cart", ["getCarts", "getModalOpen"])},
		data() {
			return {
				product: null,
				API_URL: process.env.VUE_APP_API_URL,
			};
		},
		methods: {
			formatCurrency,
			...mapActions("products", ["getProduct"]),
			...mapActions("cart", ["setModalOpen"]),
			ProductExistInCart(id) {
				return this.getCarts.find((cart) => cart.combination.id == id);
				// console.log(this.getProducts.some((product) => product.id == id))
			},
			redirectToCheckout() {
				this.setModalOpen(false);
				this.$router.push({name: "Checkout"});
			},
		},
		mounted() {
			let _this = this;
			$(this.$refs.product).on("hidden.bs.modal", function () {
				_this.setModalOpen(false);
			});
		},
		watch: {
			getModalOpen(val) {
				if (val) {
					$("#" + this.modal_id).modal("show");
					this.product = this.ProductExistInCart(this.combination_id);
				}
			},
		},
	};
</script>

<style scoped>
	.modal-content {
		height: 500px;
	}
	.modal-content .row {
		align-items: center;
	}
	.price h4{
		font-size: 16px;
	}
	@media (max-width: 767px) {
		.modal-content {
			height: 800px;
		}
	}
</style>
